// Sitewide secondary/outline button treatment, taken from the Campaign Builder
// "Previous" button (CampaignBuilderNav.tsx).
export const SECONDARY_BUTTON_CLASS =
  "font-lato font-bold text-[11px] uppercase tracking-[2px] text-rodeo-black border border-rodeo-dust";

// MUI `sx` twin: emotion's injected styles outrank Tailwind's layered utilities,
// so MUI-based secondary buttons can't take SECONDARY_BUTTON_CLASS.
export const SECONDARY_BUTTON_SX = {
  fontFamily: "var(--font-lato)",
  fontWeight: 700,
  fontSize: "11px",
  letterSpacing: "2px",
  textTransform: "uppercase",
  color: "var(--color-rodeo-black)",
  border: "1px solid var(--color-rodeo-dust)",
} as const;

/** Upgrade-drawer CTA footprint (GFG-248). `flex` overrides GfgButton's `inline-flex` so a
 *  container can right-align it via `ml-auto` or `justify-end`. */
export const DRAWER_CTA_CLASS = "flex w-2/3";
